var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      {
        staticClass: "columns is-centered h-60px pd-vtc-12px is-marginless hdr"
      },
      [
        _c(
          "div",
          { staticClass: "column is-paddingless h-36px" },
          [
            _c("router-link", { attrs: { to: { name: "Home" }, exact: "" } }, [
              _c("div", { staticClass: "cs-pointer title is-4 exit" }, [
                _c("i", { staticClass: "fas fa-times" })
              ])
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "list-item" }, [
      _c(
        "div",
        {
          staticClass:
            "pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center "
        },
        [
          _c("qrcode-reader", {
            attrs: { paused: _vm.paused },
            on: { decode: _vm.onDecode }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "columns is-centered h-100px pd-hrzt-30px is-marginless ft"
      },
      [
        _c(
          "div",
          { staticClass: "column is-6 is-paddingless" },
          [
            _c("span", { staticClass: "f-left total-price title is-3" }, [
              _vm._v(
                " ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
                  "  "
              )
            ]),
            _vm._v(" "),
            _vm.amount != 0
              ? _c(
                  "router-link",
                  {
                    staticClass: "f-right",
                    attrs: { to: { name: "Cart" }, exact: "" }
                  },
                  [
                    _c("div", [
                      this.amount !== 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "tag cart-item-count is-danger pst-absolute mg-t-15px mg-l-15px w-30px h-30px"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.amount) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "footer-icon",
                      attrs: {
                        id: "cart",
                        src: require("@/assets/shopping-cart.png")
                      }
                    })
                  ]
                )
              : _c("div", { staticClass: "f-right" }, [
                  _c("img", {
                    staticClass: "footer-icon-disable",
                    attrs: {
                      id: "cart",
                      src: require("@/assets/shopping-cart.png")
                    }
                  })
                ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-498c6584", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-498c6584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/ScanToCart.vue
// module id = 422
// module chunks = 1